import React from 'react'
import Amplify from '@aws-amplify/core'
import config from 'config/aws'
import { withAuthenticator,
	VerifyContact,
	TOTPSetup,
	Loading
} from 'aws-amplify-react'


import SignIn from './SignIn'
import ConfirmSignIn from './ConfirmSignIn'
import RequireNewPassword from './RequireNewPassword'
import ForgotPassword from './ForgotPassword'
export { isAdmin, checkAccess } from './utils'

// Amplify.Logger.LOG_LEVEL = 'DEBUG'

Amplify.configure(config)

export default Component => withAuthenticator(Component, false,
	[
		<SignIn/>,
		<RequireNewPassword/>,
		<ForgotPassword/>,
		<ConfirmSignIn/>,
		<VerifyContact/>,
		<TOTPSetup/>,
		<Loading/>
	]
)
